jQuery(function () {
    var siteCookie = $('.js-site-cookie');
    var clearCookieBtn = $('.js-clear-cookie');
    $(document)
        .ready(function () {
        checkCookie();
    });
    clearCookieBtn
        .on('click', function (e) {
        e.preventDefault();
        setCookie('AcceptedCookie', 'true', 30);
        siteCookie.removeClass('is-visible');
    });
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
    function getCookie(cname) {
        var name = cname + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
    function checkCookie() {
        var user = getCookie('AcceptedCookie');
        if (user === '') {
            siteCookie.addClass('is-visible');
        }
    }
});
